import { render, staticRenderFns } from "./MarketListPage.vue?vue&type=template&id=0e013d80&scoped=true&"
import script from "./MarketListPage.vue?vue&type=script&lang=js&"
export * from "./MarketListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e013d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e013d80')) {
      api.createRecord('0e013d80', component.options)
    } else {
      api.reload('0e013d80', component.options)
    }
    module.hot.accept("./MarketListPage.vue?vue&type=template&id=0e013d80&scoped=true&", function () {
      api.rerender('0e013d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/MarketListPage.vue"
export default component.exports